export default __webpack_public_path__ + "static/media/disconnected_icon_bold.6545e007.svg";